export let StatusEnum = /*#__PURE__*/function (StatusEnum) {
  StatusEnum["Paid"] = "paid";
  StatusEnum["Failed"] = "failed";
  return StatusEnum;
}({});
export let PayoutInvoiceType = /*#__PURE__*/function (PayoutInvoiceType) {
  PayoutInvoiceType["Payment"] = "Payment";
  PayoutInvoiceType["Refund"] = "Refund";
  PayoutInvoiceType["Dispute"] = "Dispute";
  return PayoutInvoiceType;
}({});